import { TextField, useInput, useTranslate } from "react-admin";
import React from "react";
import PartnerTypeField from "../../executive-project-collaborations/fields/PartnerTypeField";
import {
  Group,
  GroupTitle,
  LongTextField,
  ReferenceListField,
  useFieldLabel,
} from "ra-friendsofbabba";

const CollaborationsField = ({ tab = 1, ...props }) => {
  useInput({ ...props });
  const translate = useTranslate();
  const fieldLabel = useFieldLabel(props);

  return (
    <Group {...props} wrapper>
      <GroupTitle
        title={fieldLabel(props?.source)}
        subTitle={translate(
          "resources.executive-projects.fields.collaborations.help"
        )}
      />

      <ReferenceListField
        {...props}
        tab={tab}
        perPage={5}
        reference="executive-project-collaborations"
        target="executive_project_id"
        addLabel={false}
        createLabel="ra.action.add_collab"
        create={!props.disabled}
        modify={!props.disabled}
        remove={!props.disabled}
        mobilePrimaryText="partner"
        mobileSecondaryText="collaboration_type.description"
        mobileTertiaryText="description_and_goals"
        mobileBreakpoint="xs"
      >
        <LongTextField source="partner" maxRows={2} variant="body2" />
        <PartnerTypeField source="partner_type.description" />
        <TextField source="collaboration_type.description" />
      </ReferenceListField>
    </Group>
  );
};

export default CollaborationsField;
